export default __webpack_public_path__ + "static/media/2A.56087748.jpg";